import request from 'src/api'
import { controlColumn, orderFirstDataColumn, responsiveControlColumn } from 'src/datatableControl'
import deleteRecord from 'src/deleteRecord'
import { addToast } from 'src/toasts'
import { lockButton, unlockButton, hideModalKeepLoader } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { assignPresent, camelize } from 'src/misc'
import initDatatableChrome from 'src/datatableChrome'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  // set dropdown values from local storage
  const usersIndexSelectRole = localStorage.getItem("usersIndexSelectRole")
  if (usersIndexSelectRole) {
    $("#select-role").val(usersIndexSelectRole)
  }
  const usersIndexSelectBu = localStorage.getItem("usersIndexSelectBu")
  if (usersIndexSelectBu) {
    $("#select-bu").val(usersIndexSelectBu)
  }

	// datatable init
  let usersDatatable = $('#users-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('usersIndexPageLength') || 25),
    "processing": true,
    "order": orderFirstDataColumn(),
    // TODO.md U-76 / F-123: the control column lives in src/datatableControl.js — the reasoning, the
    // library line numbers and the lost-ORDER-BY measurement are all there, once.
    "responsive": responsiveControlColumn(),
    "serverSide": true,
    "ajax": {
      "url": $('#users-datatable').data('source'),
      "data": function (d) {
        assignPresent(d, { role: $('#select-role').val(), bu: $('#select-bu').val() })
      }
    },
    "columns": [
      controlColumn(),
      { "data": "first_name" },
      { "data": "last_name" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "role" },
      { "data": "title" },
      { "data": "company" },
      { "data": "business_units" },
      { "data": "sign_in_count" },
      { "data": "current_sign_in_at" },
      { "data": "actions", "orderable": false, "className": "all" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('users-datatable')
  	}
  })

  // T-102 / T-108 / U-48: reload this page's table when a save says so. The `off()`/`on()` pair and
  // `resetPaging: false` live in `src/indexRefresh` — five packs carried a copy of both.
  onIndexRefresh('usersIndex', usersDatatable)

  $('#content').on('change', "[name='users-datatable_length']", function() {
    localStorage.setItem('usersIndexPageLength', $(this).val())
  })

  $('#content').on('change', '#select-role, #select-bu', function() {
    localStorage.setItem(camelize('users-index-' + $(this).attr('id')), $(this).val())
    usersDatatable.ajax.reload()
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    usersDatatable.search('').draw()
  })

  $('#content').on('click', '#add_user', function() {
    lockButton('#add_user')
    offcanvasRight.show()
    $.getScript('/users/new')
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    $(this).blur()

    if ($("body.users.index").length) {
      lockButton('#confirmDelete')
      let params = $('#confirmDelete').data('id')
      let p = ''
      if ($('#transferCustomers').length) {
        p += '?new_customer_id=' + $('#transferCustomers').val()
      }
      if ($('#transferEvents').length) {
        if (p.length > 0) {
          p += '&'
        } else {
          p += '?'
        }
        p += 'new_event_id=' + $('#transferEvents').val()
      }
      params += p
      
      // T-111: `deleteRecord` clears `dirty` before the close below — see F-148.
      deleteRecord(`/users/${params}`)
        .then(res => {
          addToast(res.body.success, 'notice')
          usersDatatable.ajax.reload()
          mainModal.hide()
          $('#offcanvasRight .btn-close').click()
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })

  $('#content').on('click', '.delete-user', function() {
    const btn = this
    lockButton(btn)
    const id = $(btn).data('id')
    $.getScript('/users/' + id + '/delete_modal')
      .then(() => unlockButton(btn))
      .catch(err => handleErrors(err, btn))
  })

  $('#content').on('click', '.transfer-user-data', function() {
    const btn = this
    lockButton(btn)
    const id = $(btn).data('id')
    const buId = $(btn).data('bu_id')
    let url = '/users/' + id + '/transfer_modal'
    if (buId) url += '?bu_id=' + buId
    $.getScript(url)
      .then(() => unlockButton(btn))
      .catch(err => handleErrors(err, btn))
  })

  $('#mainModal').on('click', '#confirmTransferUserData', function(event) {
    const customer = $('#transfer-user-data-customers').is(':checked')
    const qualityControls = $('#transfer-user-data-quality-controls').is(':checked')

    if (customer || qualityControls) {
      lockButton('#confirmTransferUserData')

      let params = '?user_id=' + $(this).data('id')
      params += '&new_user_id=' + $('#transfer-user-data-user-select').val()
      if (customer) {
        params += '&customers=true'
      }
      if (qualityControls) {
        params += '&quality_controls=true'
      }
      
      request.post('/move_user_data' + params)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          // Moving a user's data can take a while: keep the loader up for the whole wait, and
          // return the poll so the unlock below -- which releases it -- waits for the job.
          hideModalKeepLoader()
          return waitForJob(res.body.jobId, { intervalMs: 1000, timeoutMs: 120000 })
            .then(({ result }) => {
              if (result === 1) {
                addToast(I18n.t('move_user_data.success'), 'notice')
              }
            })
            .catch(err => handleErrors(err, null))
        })
        .catch(err => {
          handleErrors(err, '#confirmTransferUserData')
        })
        .finally(() => unlockButton('#confirmTransferUserData'))
    } else {
      addToast(I18n.t("errors.no_transfer_data"), 'alert')
    }
  })

  // U-23: release a Devise :lockable lock before its 30 minutes are up, for the office to use when the
  // locked person phones. Delegated from #offcanvasRight because the panel holding the button is replaced
  // wholesale by edit.js.erb — a handler bound to #unlock-user itself would die on the first re-render.
  $('#offcanvasRight').on('click', '#unlock-user', function() {
    const btn = this
    lockButton(btn)
    const id = $(btn).data('id')
    request.put(`/users/${id}/unlock`)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        addToast(res.body.success, 'notice')
        // Re-fetch the panel rather than hiding the banner here: `access_locked?` is the server's answer,
        // and this way the one that renders it is the one that decides.
        return $.getScript(`/users/${id}/edit`).then(() => unlockButton(btn))
      })
      .catch(err => handleErrors(err, btn))
  })
}
